import { render } from "./ArticlesDetails.vue?vue&type=template&id=152d4aae&ts=true"
import script from "./ArticlesDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlesDetails.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/ArticlesDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "152d4aae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('152d4aae', __exports__)) {
    api.reload('152d4aae', __exports__)
  }
  
  module.hot.accept("./ArticlesDetails.vue?vue&type=template&id=152d4aae&ts=true", () => {
    api.rerender('152d4aae', render)
  })

}


export default __exports__